import { ZodType } from "zod";

export function createJsonParser<T>(schema: ZodType<T>) {
  return {
    parse(json: string): T {
      return schema.parse(JSON.parse(json));
    },
    safeParse(json: string): { success: true; data: T } | { success: false; error: any } {
      try {
        return { success: true, data: schema.parse(JSON.parse(json)) };
      } catch (error) {
        return { success: false, error };
      }
    },
  };
}
